import React from "react";
import {Link} from "react-router";
import { DateRange } from 'react-date-range';
import moment from "moment";

import FormItem from "./FormItem";
import Right from "./Right";
import Panel from "./Panel";
//import ChartMaker from "./ChartMaker";

import ChartMaker from "./UI/ChartMaker/ChartMaker";
import PanelEditor from "./UI/PanelEditor/PanelEditor";

import CoolLoader from "./CoolLoader";
import CoolLoader2 from "./CoolLoader2";
import {api, get, classLoader, parsePHPtime, s2ab} from "./baseFunctions";
import Maps from "./Maps";
import langs from "./langs/phpIndex";

//import XLSX from 'xlsx';
import {saveAs} from "file-saver";
import "./css/dashboard.css";
import "./css/other.css";
import "./css/filters.css";

//import svgSpinner from "./images/spinner.svg";

export default class RiskAssessment extends React.Component {
	constructor(props){
		super(props);
    this.getData = this.getData.bind(this);
    this.getRA = this.getRA.bind(this);
    this.mapExtra = this.mapExtra.bind(this);
    this.drawChart = this.drawChart.bind(this);
    this.preloadReport = this.preloadReport.bind(this);
    this.deleteRA = this.deleteRA.bind(this);
    this.table = false;
    this.doShit = props.firm === "18";
		this.state = {
			data: [],
      panels: [],
      editPanels: [],
      sheets: [],
      search: false,
      popped: false,
      showExport: false,
      exporting: false,
      exportAmount: 0,
      exportStart: 0,
      exportInterval: {
        from: 0,
        to: moment(),
      },
      editingPanels: false,
      editingPanels2: false,
      currPoints: [],
      currFilters: false,
      showReport: props.params.id ? Number(props.params.id) : false,
      reportData: {
        name: "",
        customer: "",
        createdBy: "",
        start: "",
        end: "",
        questions: [],
        preQuestions: 0,
      }
		};
	}
	componentDidMount(){
		this.getData(() => {
      if(this.props.params.id)
      {
        this.getRA(Number(this.props.params.id));
      }
    });

    api("POST", {"type": "getPanels", page: "ra"}, (d) => {
      if(!d.error)
      {
        this.setState({panels: d.data});
      }
    }, this.props.auth, 1);

    api("POST", {"type": "getPanels", page: "editRa"}, (d) => {
      if(!d.error)
      {
        this.setState({editPanels: d.data});
      }
    }, this.props.auth, 1);
	}

  deleteRA(id)
  {
    var sure = window.confirm(langs[this.props.lang].REMOVE_RA_MSG + id);
    if(!sure)
    {
      return 1;
    }
    api("POST", {"type": "deleteRA", id: id}, (d) => {
      console.log(d);
      if(!d.error)
      {
        this.getData();
      }
    }, this.props.auth, true);
  }
  preloadReport(id){
    const curr = this.state.data[id];
    var data = {...this.state.reportData};

    data.name = curr.name;
    data.start = curr.time;
    data.end = curr.date;
    data.createdBy = curr.createdBy;
    data.customer = curr.customer;
    data.questions = [];
    this.setState({reportData: data, showReport: Number(curr.id)});
    this.getRA(curr.id);
  }
  getRA(id)
  {
    api("POST", {"type": "getRA", id}, (d) => {
      if(!d.error)
      {
        let currPoints = [];
        let currFilters = false;
        if(this.doShit)
        {
          console.clear();
          for(let i = 0; i < d.data.questions.length; i++)
          {
            let currE = d.data.questions[i].extra[0];
            if(currPoints.indexOf(Number(currE.value)) === -1)
            {
              currPoints.push(Number(currE.value));
            }
          }
          currPoints = currPoints.sort((a,b) => a - b);
          currFilters = currPoints;
        }
        this.setState({reportData: d.data, currPoints, currFilters});
        this.state.data.filter((d) => d.boundTo === id).map((dat) => {
          api("POST", {"type": "getRA", id: dat.id}, (resp) => {
            if(!resp.error)
            {
              var reportData = {...this.state.reportData};
              resp.data.questions[0].newTitle = true;
              reportData.questions = [
                ...reportData.questions,
                ...resp.data.questions
              ];
              
              this.setState({reportData});
              //this.setState({reportData: d.data});
            }else{
              alert(resp.msg);
            }
          }, this.props.auth);
        });
      }else{
        alert(d.msg);
      }
    }, this.props.auth, 1);

  }
  drawChart(d){
    var ctx = this.canvas;
    var dataSet = {};
    d.map((d, key) => {
      if(Object.keys(dataSet).length < 30 && d.points > 0)
      {
        var date = new Date(d.time * 1000);
        var index = date.getDate() + "/" + date.getMonth(); 
        dataSet[index] = dataSet[index] ? dataSet[index] + d.points : d.points;
      }
    });
    var largestY = 0;
    var chart = new window.Chart(ctx, {
        type: 'line',
        data: {
            labels: Object.keys(dataSet).reverse(),
            datasets: [{
                label: "Point",
                backgroundColor: 'rgba(42, 63, 84, 0.74)',
                borderColor: 'rgba(42, 63, 84, 0.74)',
                data: Object.keys(dataSet).map((key) => {
                  var curr = dataSet[key];
                  if(curr > largestY)
                  {
                    largestY = curr;
                  }
                  return curr;
                }).reverse(),
            }]
        },

        // Configuration options go here
        options: {
              responsive: true,
              tooltips: {
                mode: "index",
                intersect: false,
              },
              hover: {
                mode: "index",
                intersect: false
              },
          scales: {
        yAxes: [{
                            display: true,
                            ticks: {
                                beginAtZero: true,
                                steps: 10,
                                stepValue: 5,
                                max: largestY
                            }
                        }]
    }
        }
    });
    ctx.addEventListener("click", (ev) => {
      var activePoints = chart.getElementsAtEvent(ev);
      if(activePoints.length > 0)
      {
        var clickedElementindex = activePoints[0]["_index"];
        var label = chart.data.labels[clickedElementindex];   
        var value = chart.data.datasets[0].data[clickedElementindex];
        //this.dataTable.search("Kenneth").draw();
        label = label.split("/");
        label[0] = label[0] < 10 ? "0" + label[0] : label[0];
        label[1] = label[1] < 10 ? "0" + label[1] : label[1];
        label = label[1] + "-" + label[0];
        var table = window.$('#ras').DataTable();
        table.search(label).draw();
     }
    });
  }
	getData(callback){
		api("POST", {"type": "getRAs"}, (d) => {
			if(!d.error)
			{
        //return 1;
				this.setState({
          data: d.data,
          sheets: d.sheets,
          popped: true
				});
        //this.drawChart(d.data);
        if(this.table)
        {
          this.table.fnDestroy();
        }
				this.table = window.$("#ras").dataTable(langs[this.props.lang].DATA_OPTIONS);
        if(callback)
        {
          callback();
        }
			}
		}, this.props.auth);
	}
  mapExtra(d, type, val2)
  {
    switch (type) {
      case "RA_inputs":
        if(val2)
        {
          return (<div>{d.value2}</div>);
        }else{
          return (<div>{d.value}</div>);
        }
        break;
      default:
        return d.value + " / " + d.to;
        break;
    }
    
  }
	render(){
    const LANG = langs[this.props.lang];
    const repData = this.state.reportData;
    var tempI = 0;
    //console.log(this.state);
    let rawExportTime = (this.state.exportAmount * 1.15) + 35 * 2;
    let exportMins = Math.floor(rawExportTime/60);
    let exportSek = Math.round(((rawExportTime/60) - exportMins) * 60);
    const LANG_FIX = {
        "DK": "DK",
        "EN": "UK",
        "UK": "UK"
    };
		return (
			<Right title={LANG.ANSWERS} token={this.props.auth} lang={this.props.lang}>
        {
          typeof this.state.showReport === "number" ? 
          <div>
            <Panel title="Generel information" size="custom3" custom="8" customIcons={repData.id ? () => 
                    <li>
                      <a className="collapse-link" target="_blank" href={"https://safeallday.dk/administration/getPDF.php?type=obs&hash=" + repData.hash + "&show=" + repData.id}>
                          <i className="fa fa-file-pdf-o"></i>
                      </a>
                    </li> : null}>

              <CoolLoader show={repData.name.length === 0} type="inputs"/>
              <div style={repData.name.length === 0 ? {"display": "none"} : {}}>
                <FormItem name={LANG.TITLE}>
                  <input type="text" className="form-control col-md-7 col-xs-12" ref="name" value={repData.name} disabled={true} required=""/>
                </FormItem>
                <FormItem name={LANG.CUSTOMER}>
                  <input type="text" className="form-control col-md-7 col-xs-12" ref="name" value={repData.customer} disabled={true} required=""/>
                </FormItem>
                <FormItem name={LANG.CREATED_BY}>
                  <input type="text" className="form-control col-md-7 col-xs-12" ref="name" value={repData.createdBy} disabled={true} required=""/>
                </FormItem>
                <FormItem name={LANG.START_TIME}>
                  <input type="text" className="form-control col-md-7 col-xs-12" ref="name" value={repData.time ? parsePHPtime(repData.time) : ""} disabled={true} required=""/>
                </FormItem>
                {
                  typeof repData.endedTime === "number" ?
                  <FormItem name={LANG.END_TIME}>
                    <input type="text" className="form-control col-md-7 col-xs-12" ref="name" value={repData.finished ?
                              (
                                repData.signDate === 1 ?
                                  parsePHPtime(repData.endedTime)
                                : LANG['ANON']
                              )
                            : LANG['NOT_DONE']} disabled={true} required=""/>
                  </FormItem>
                   : null
                }
              </div>
            </Panel>
            {
              this.props.rank === -1 ?
                <button onClick={() => this.setState({editingPanels2: !this.state.editingPanels2})}>Edit stats</button>
              : null
            }
            
            {
              this.state.editingPanels2 ?
                <PanelEditor panels={this.state.editPanels} save={(editPanels) => {
                  api("POST", {"type": "savePanels", page: "editRa", data: editPanels}, (d) => {}, this.props.auth, 1);
                  this.setState({editPanels, editingPanels2: false});
                }}/>
              : 
                <ChartMaker types={this.state.editPanels.map((d) => d.type)} extraData={{editID: this.props.params.id}} interval={{
                  from: moment().subtract(1, 'month').unix(),
                  to: moment().unix()
                }} auth={this.props.auth} key={this.state.editPanels.length} lang={this.props.lang}/>
            }
            {
              this.state.editPanels.length === 0 ?
                <Panel title={LANG.MAP} size="custom3" custom="4">
                    {
                      repData.gps && repData.gps.length > 0 ? 
                      <Maps style={{height: "380px"}} key={"map" + repData.id} data={[repData.gps]} info={[repData]} />
                      : <CoolLoader show={1} type="worldMap" style={{minHeight: "180px"}}/>
                    }
                </Panel>
              : null
            }
            
            <Panel title="Rapport">
              <CoolLoader2 show={repData.questions.length === 0} type="table"/>
              {
                this.doShit && this.state.currPoints.length > 1 ?
                  <form ref="pointFilerForm" onChange={(e) => this.setState({currFilters: this.refs.currPointsArr.filter((d) => d.checked).map((d) => Number(d.value))})}>
                    <div className="filter-panel">
                    
                    {
                      this.state.currPoints.map((d, key) => <div key={key}>
                        <label>{d}</label> <input type="checkbox" name="type" value={d} key={key} checked={this.state.currFilters.indexOf(d) !== -1} ref={(r) => {
                          if(!this.refs.currPointsArr)
                          {
                            this.refs.currPointsArr = [];
                          }
                          this.refs.currPointsArr[key] = r;
                        }}/>
                      </div>)
                    }
                    </div>
                  </form>
                : null
              }
              
              <table className="table table-striped jambo_table bulk_action" style={repData.questions.length === 0 ? {"display": "none"} : {}}>
                <thead>
                  <tr className="headings">
                    <th className="column-title">{LANG.QUESTIONS}</th>
                    <th className="column-title">{LANG.ANSWER}</th>
                    <th className="column-title">{LANG.CORRECT}</th>
                    <th className="column-title">{LANG.POINT}</th>
                    <th className="column-title">{LANG.ANSWER_CHANGED}</th>
                    <th className="column-title">{LANG.COMMENT}</th>
                  </tr>
              </thead>
                {
                  repData.questions.filter((d) => this.doShit ? (this.state.currFilters.indexOf(Number(d.extra[0].value)) !== -1) : true).map((d, key) => {
                      tempI++;
                      var ret = [];
                      //console.log(d);
                      if(d.newTitle)
                      {
                        console.log("title", d);
                        ret.push(<tr key={"h" + key} className="headings" style={{
                          "background": "rgba(52,73,94,0.76)",
                          "color": "#ECF0F1"
                      }}>
                                    <th className="column-title">{LANG.QUESTIONS}</th>
                                    <th className="column-title">{LANG.ANSWER}</th>
                                    <th className="column-title">{LANG.CORRECT}</th>
                                    <th className="column-title">{LANG.POINT}</th>
                                    <th className="column-title">{LANG.ANSWER_CHANGED}</th>
                                    <th className="column-title">{LANG.COMMENT}</th>
                                </tr>);
                      }
                      if(d.type === "RA_yesNo")
                      {
                        ret.push(<tr key={"q" + key} className={key%2 ? "odd pointer" : "even pointer"}>
                              <td className=" ">{d.texts[LANG_FIX[this.props.lang]]}</td>
                              <td className=" ">{d.value === "1" ? LANG["YES/NO"]["1"] : LANG["YES/NO"]["2"]}</td>
                              <td className=" ">{d.value === d.correct ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</td>
                              <td className=" ">{d.extra.reduce((a,b,i) => i === 1 ? a * b.points : a + b.points ,0)}</td>
                              <td className=" ">{d.history}</td>
                              <td className=" ">{d.comment}</td>
                              
                              </tr>);
                      }else if(d.type === "RA_inputs")
                      {
                        ret.push(d.extra.map((dat, dI) => {
                          return (<tr key={"q" + key + "-" + dI} className={key%2 ? "odd pointer" : "even pointer"}>
                              <td className=" ">{this.mapExtra(dat, d.type, 1)}</td>
                              <td className=" " colSpan="5">{this.mapExtra(dat, d.type)}</td>
                              </tr>);
                        }));

                      }else if(d.type === "RA_signature" || d.type === "RA_drawing")
                      {
                         ret.push(<tr key={"q" + key} className={key%2 ? "odd pointer" : "even pointer"}>
                              <td className=" ">{d.texts[LANG_FIX[this.props.lang]]}</td>
                              <td className=" "></td>
                              <td className=" " colSpan="4">
                                  <img style={{maxHeight: "100px"}} src={"https://safeallday.dk/new/img/uploads/" + d.value} />
                              </td>
                              </tr>);
                      }else if(d.type === "RA_map")
                      {
                        let gps = d.value.split(" ");
                         ret.push(<tr key={"q" + key} className={key%2 ? "odd pointer" : "even pointer"}>
                              <td className=" ">{d.texts[LANG_FIX[this.props.lang]]}</td>
                              <td className=" "></td>
                              <td className=" " colSpan="4">
                                <Maps style={{height: "300px"}} key={"map" + repData.id} data={[{
                                  lat: gps[0],
                                  lng: gps[1]
                                }]} info={[repData]} />
                              </td>
                              </tr>);
                      }else{
                        ret.push(<tr key={"q" + key} className={key%2 ? "odd pointer" : "even pointer"}>
                              <td className=" ">{d.texts[LANG_FIX[this.props.lang]]}</td>
                              <td className=" ">{d.extra.map((dat) => this.mapExtra(dat, d.type))}</td>
                              <td className=" "></td>
                              <td className=" "></td>
                              <td className=" ">1</td>
                              <td className=" ">{d.comment}</td>
                              
                              </tr>);
                      }
                      //console.log("Ret", ret);
                      return (<tbody key={"oQ" + key}>
                        {
                          ret.map((d) => d)
                        }
                      </tbody>);
                  })
                }
              </table>
            </Panel>
          </div>: ""
        }
        {
          this.props.rank === -1 ? 
            <button onClick={() => this.setState({editingPanels: !this.state.editingPanels})}>Edit stats</button>
          : null
        }
        {
          this.state.editingPanels ?
            <PanelEditor panels={this.state.panels} save={(panels) => {
              api("POST", {"type": "savePanels", page: "ra", data: panels}, (d) => {}, this.props.auth, 1);
              this.setState({panels, editingPanels: false});
            }}/>
          : 
            <ChartMaker types={this.state.panels.map((d) => d.type)} interval={{
              from: moment().subtract(1, 'month').unix(),
              to: moment().unix()
            }} auth={this.props.auth} lang={this.props.lang}/>
        }

        {/*<Panel title={LANG.STATISTIC}>
            <CoolLoader2 show={!this.state.popped} type="lineGraph" width="600" height="120"/>
            <canvas ref={(me) => this.canvas = me} width="600" height="120" style={!this.state.popped ? {width: "100%", "display": "none"} : {width: "100%"}}></canvas>
            {
              this.state.popped ? 
                <ChartMaker type="RAstats" data={this.state.data} auth={this.props.auth}/>
              : null
            }
        </Panel>*/}
        {
          this.state.showExport ?
            <Panel title="Exporter" hidden={0}>
              {
                this.state.exporting ?
                <div>
                  <img src="/administration/includes/images/spinner.svg" style={{width: "30px"}}/>
                  Exportere data..<br/>
                  <small>Esimeret tid: {exportMins} minutter og {exportSek} sekunder</small>
                </div>
                : 
                <div>
                  <DateRange maxDate={moment()}  theme={{DaySelected: {background: '#1ABB9C'}}}
                  onChange={(d) => {
                    if(d.startDate.unix() !== d.endDate.unix())
                    {
                      this.setState({
                          exportInterval: {
                            from: d.startDate.unix(),
                            to: d.endDate.unix(),
                          }
                        });
                    }
                  }}
                />
                <div className="panelBottom">
                  <select ref="sheetPicker">
                    {
                      this.state.sheets.map((d) => <option value={d.id} key={"pick" + d.id}>{d.name}#{d.id}</option>)
                    }
                  </select>
                   <button onClick={() => {
                    if(this.state.exportInterval.from > 0 && this.state.exportInterval.to > 0)
                    {
                      /*api("POST", {"type": "exportRA", "to": this.state.exportInterval.to, "from": this.state.exportInterval.from, "sheet": this.refs.sheetPicker.value}, (resp) => {
                      
                      }, this.props.auth, 1);*/
                      this.setState({
                        exporting: true,
                        exportAmount: this.state.data.filter((d) => d.sheetID === this.refs.sheetPicker.value & d.time > this.state.exportInterval.from && d.time < this.state.exportInterval.to).filter((d) => !d.boundTo).length,
                        exportStart: Date.now()
                      });
                      //return; "exportRAneu"
                      get("POST", {"type": "exportRAneu", "to": this.state.exportInterval.to, "from": this.state.exportInterval.from, "sheet": this.refs.sheetPicker.value}, () => {
                        this.setState({exporting: false});
                      }, this.props.auth, 1);
                    
                    }
                   }} disabled={this.state.exporting}>
                     {this.state.exporting ? "Henter data.." : "Hent"}
                   </button>
                 </div>
                </div>
              }
              
              
            </Panel>
          : null
        }
				<Panel title={LANG.VIEW} customIcons={() => 
                    <li>
                      <a className="collapse-link" onClick={() => this.setState({showExport: !this.state.showExport})}>
                          <i className="fa fa-file-excel-o"></i>
                      </a>
                    </li>}>
					<div className="table-responsive">
            <CoolLoader2 show={!this.state.popped} type="table"/>
            
            <table className="table table-striped jambo_table bulk_action" id="ras" style={!this.state.popped ? {"display": "none"} : {}}>
            		<thead>
                  <tr className="headings">
                      <th className="column-title"># </th>
                      <th className="column-title">{LANG.TITLE}</th>
                      <th className="column-title">{LANG.STARTED_DATE}</th>
                      {
                        this.state.data.length === 0 || typeof this.state.data[0].endedTime === "number" ?
                          <th className="column-title">{LANG.DONE}</th>
                        : null
                      }
                      <th className="column-title">{LANG.BY}</th>
                      <th className="column-title">{LANG.SHEET}</th>
                      <th className="column-title">{LANG.POINT}</th>
                      <th className="column-title">{LANG.NOTES_AMOUNT}</th>
                      <th className="column-title">{LANG.ADDRESS}</th>
                      <th className="column-title"> </th>
                  </tr>
              	</thead>
                <tbody>
                {
                	this.state.data.map((d, key) => {
                    if(d.boundTo)
                    {
                      return null;
                    }
                    //console.log(d);
                    const sheet = this.state.sheets.find((sheet) => sheet.id === d.sheetID);
                		return (<tr key={key} className={key%2 ? "even pointer" : "odd pointer"}>
                        <td className=" ">{d.id}</td>
                        <td className=" ">{d.name}</td>
                        <td className=" ">{parsePHPtime(d.time)}</td>
                        {
                          typeof d.endedTime === "number" ?
                            <td className=" ">
                            {
                              d.finished ?
                                (
                                  d.signDate === 1 ?
                                    parsePHPtime(d.endedTime)
                                  : <i className="fa fa-check"></i>
                                )
                              :
                                <i className="fa fa-times"></i>
                            }
                            </td>
                          : null
                        }
                        <td className=" ">{d.uID ? <Link to={"/user/" + d.uID}>{d.createdBy}</Link> : d.createdBy}</td>
                        <td className=" ">{sheet ? sheet.name + "#" + sheet.id : "POWRA"}</td>
                        <td className=" ">{d.points}</td>
                        <td className=" ">{d.commentsAmount}</td>
                        <td className=" ">{d.address}</td>
                        <td className=" last">
                        	<Link to={"/ra/" + d.id} onClick={() => this.preloadReport(key)}>{LANG['SHOW_REPORT']}</Link> / <a target="_blank" href={"https://safeallday.dk/administration/showNewReport.php?show=" + d.id + "&lang=DK&hash=" + d.hash}>{LANG["EXTERNAL_REP"]}</a> / <Link onClick={() => this.deleteRA(d.id)} to="/ra">{LANG["REMOVE"]}</Link>
                        </td>
                        {/*<td className=" ">
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </td>*/}
                    </tr>);
                	})
                }                 
                </tbody>
            </table>
        </div>
				</Panel>
			</Right>);
	}
}


/*
var wb = {
                        "SheetNames": [],
                        "Sheets": {}
                      };
                      var reps = this.state.data.filter((d) => d.time > this.state.exportInterval.from && d.time < this.state.exportInterval.to).filter((d) => !d.boundTo).map((d) => [d.id, d.name, d.createdBy, parsePHPtime(d.time), d.customer]);
                      var new_ws_name = "Rapporter";
                      var ws_data = [
                        ["#"  ,"Titel" ,"Lavet af" ,"Dato" ,"Kunde"],
                        ...reps
                      ];
                      var ws = XLSX.utils.aoa_to_sheet(ws_data);

                      wb.SheetNames.push(new_ws_name);

                      wb.Sheets[new_ws_name] = ws;
                      var wbout = XLSX.write(wb, {
                            bookType: "biff8",
                            bookSST: true,
                            type: 'binary'
                        });
                      var fname = "RA-" + this.state.exportInterval.from + "-" + this.state.exportInterval.to + ".xls";

                    saveAs(new Blob([s2ab(wbout)],{
                                type: "application/octet-stream"
                            }), fname);
                    this.setState({showExport: 0});

*/


// WEBPACK FOOTER //
// ./src/components/RiskAssessment.js